// extracted by mini-css-extract-plugin
export default {"container":"services_container__k7Spw","wrapper":"services_wrapper__jP6hI","add":"services_add__MQDFA","active":"services_active__GViC1","main":"services_main__O7vQi"};